import { fileTypeFromBuffer } from "file-type";

/**
 * Detects if a file is HEIC/HEIF using magic bytes and converts it to JPEG.
 * Returns the original file unchanged if it's not HEIC/HEIF.
 */
export async function convertHeicToJpeg(file: Blob): Promise<Blob> {
  const slice = file.slice(0, 4100);
  const arrayBuffer = await slice.arrayBuffer();
  const fileTypeResult = await fileTypeFromBuffer(arrayBuffer);
  const detectedType = fileTypeResult?.mime ?? (file instanceof File ? file.type : "");

  if (["image/heic", "image/heif"].includes(detectedType)) {
    const { heicTo } = await import("heic-to");
    return heicTo({ blob: file, type: "image/jpeg", quality: 0.8 });
  }

  return file;
}
